module.exports = __webpack_public_path__ + "img/it-team.d829baef.png";